import React from "react";

export default function ManualPricingSVG(props) {
  const {styles:{fill}} = props;
  return (
    <svg
      width="50px"
      height="50px"
      viewBox="0 0 50 50"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      fill={fill}
    >
      <title>manual pricing</title>
      <desc>Created with Sketch.</desc>
      <defs>
        <polygon
          id="path-1"
          points="0.106047707 0.467191351 43.0119523 0.467191351 43.0119523 50.3363668 0.106047707 50.3363668"
        ></polygon>
      </defs>
      <g
        id="Pricing"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Desktop---M-Pricing-[nice]"
          transform="translate(-82.000000, -458.000000)"
        >
          <g id="Group-5" transform="translate(48.000000, 441.000000)">
            <g id="Group-6">
              <g
                id="manual-pricing"
                transform="translate(30.000000, 11.000000)"
              >
                <g id="Group-4">
                  <g
                    id="Group-3"
                    transform="translate(30.693919, 31.564480) rotate(17.000000) translate(-30.693919, -31.564480) translate(8.693919, 6.064480)"
                  >
                    <mask id="mask-2" fill="white">
                      <use xlinkHref="#path-1"></use>
                    </mask>
                    <g id="Clip-2"></g>
                    <path
                      d="M40.8691304,18.4230783 L22.7168201,48.2725737 L2.28220186,37.0978891 L20.4345121,7.24839373 C20.9652814,6.34233823 21.8675893,5.6879648 22.9291279,5.43628272 L36.5168221,2.01340635 C37.0475914,1.8623971 37.5783607,2.1644156 37.6845146,2.66777977 L41.2937459,15.5035661 C41.5591305,16.5102945 41.4535074,17.5673593 40.8691304,18.4230783 L40.8691304,18.4230783 Z M39.2237456,2.26508844 C38.8522071,0.95634159 37.4727376,0.201295332 36.0922067,0.553650252 L22.5045124,3.97652662 C21.0188891,4.37921796 19.797589,5.28527347 19.0545119,6.49334748 L0.106047707,37.6515897 L23.3006664,50.3363668 L42.2496614,19.1781246 C42.9922076,17.9197142 43.2045154,16.4599581 42.8329768,15.1008748 L39.2237456,2.26508844 Z"
                      id="Fill-1"
                      fill={fill}
                      mask="url(#mask-2)"
                    ></path>
                  </g>
                  <path
                    d="M44.3928286,16.885351 C44.7209691,16.3464803 45.2669599,15.9153838 45.8670037,15.7537226 C46.085946,15.6998355 46.3037963,15.6459485 46.5221926,15.6459485 C46.9589852,15.6459485 47.3411788,15.7537226 47.7239183,15.9692709 C48.8699529,16.6159157 49.3067455,18.0708665 48.5969575,19.2563819 C48.269909,19.7952526 47.7239183,20.2263491 47.1227825,20.3880103 C46.5221926,20.5496715 45.8670037,20.4418974 45.2669599,20.1724621 C44.1198333,19.4719302 43.7381857,18.0169794 44.3928286,16.885351 M44.5020268,21.5735258 C45.1031626,21.9507353 45.8129506,22.1123965 46.5221926,22.1123965 C46.8497871,22.1123965 47.2319806,22.0585094 47.5601211,21.9507353 C48.5969575,21.6812999 49.4710887,21.0346551 50.0170795,20.0646879 C51.1631141,18.1247535 50.4538721,15.6998355 48.5429044,14.5682071 C47.6141741,14.0293365 46.5221926,13.8676753 45.4848102,14.1909977 C44.4479737,14.460433 43.5738425,15.1070778 43.0278517,16.077045 C41.8812711,17.9630923 42.537006,20.4418974 44.5020268,21.5735258"
                    id="Fill-4"
                    fill={fill}
                    transform="translate(46.516414, 18.068751) rotate(17.000000) translate(-46.516414, -18.068751) "
                  ></path>
                  <path
                    d="M44.3682272,23.7481648 L29.3773016,49.6885335 L16.1649604,42.0590133 L31.155886,16.1186446 L44.3682272,23.7481648 Z M14.0814758,42.6185114 L29.987102,51.7739357 L46.5025285,23.1886667 L30.5969023,14.0332425 L14.0814758,42.6185114 Z"
                    id="Fill-6"
                    fill={fill}
                    transform="translate(30.292002, 32.903589) rotate(17.000000) translate(-30.292002, -32.903589) "
                  ></path>
                  <path
                    d="M21.1976787,42.2503448 C21.3036778,42.3025103 21.462711,42.3544664 21.5687793,42.3544664 C21.8339501,42.3541167 22.0993284,42.1968512 22.2587769,41.9351149 L35.6003836,19.2170614 C35.8130047,18.8506446 35.7075592,18.3800365 35.336597,18.1713045 C34.9656347,17.9625724 34.488189,18.0678121 34.2755679,18.434229 L20.933892,41.2045878 C20.721271,41.5710046 20.8267164,42.0416127 21.1976787,42.2503448"
                    id="Fill-8"
                    fill={fill}
                    transform="translate(28.267138, 30.209835) rotate(17.000000) translate(-28.267138, -30.209835) "
                  ></path>
                  <path
                    d="M25.2871667,46.2902682 C25.3928815,46.3424342 25.5514881,46.3943912 25.6572721,46.3943912 C25.9217319,46.3940424 26.1863993,46.2367779 26.3454212,45.9750422 L39.6513384,23.2570357 C39.8633907,22.8906196 39.7582296,22.4200111 39.3882627,22.2112778 C39.0182958,22.0025445 38.5421297,22.1077825 38.3300774,22.4741986 L24.9712683,45.1922747 C24.759216,45.5586908 24.917269,46.0292296 25.2871667,46.2902682"
                    id="Fill-10"
                    fill={fill}
                    transform="translate(32.317866, 34.249783) rotate(17.000000) translate(-32.317866, -34.249783) "
                  ></path>
                  <path
                    d="M13.4399779,35.6246459 L14.2067821,34.3350484 L12.4228615,33.3465599 L13.9564023,30.8183932 L13.4978672,30.4226617 C12.3770325,29.4332993 11.460421,28.2950418 10.7989737,27.057364 L10.493655,26.5128046 L7.58529455,27.2597673 L6.51933391,23.3473557 L9.42769438,22.600393 L9.42848097,22.0058882 C9.37937526,20.5692355 9.58530264,19.1322467 9.9951916,17.7440356 L10.1999385,17.1992994 L7.54956076,15.716533 L9.64542052,12.2458322 L12.2957982,13.7285986 L12.7044418,13.2816868 C13.7260155,12.1909123 14.9003483,11.2971136 16.1763652,10.6518816 L16.7378313,10.3538897 L15.9254617,7.5310675 L19.9053544,6.48544074 L20.6667181,9.30783477 L21.2787975,9.3070281 C22.7580543,9.256032 24.2369841,9.45225081 25.664645,9.84670511 L26.2254563,10.0436385 L27.7589971,7.51547185 L29.5429178,8.50396039 L30.3097213,7.21485832 L27.251684,5.43537728 L25.5647949,8.21195136 C24.3410293,7.9163123 23.1171327,7.71975738 21.8929738,7.72137072 L21.0299915,4.60086789 L14.0396589,6.44362928 L14.9026425,9.56314126 C13.8307163,10.1595532 12.8096007,10.9040286 11.9413089,11.7964332 L9.08710076,10.1658049 L5.45763393,16.2147098 L8.31184145,17.8458335 C8.00422857,19.0352465 7.79862959,20.2240295 7.79705576,21.4135345 L4.63346556,22.3094595 L6.51179582,29.0446933 L9.7263271,28.1982432 C10.33703,29.2378199 11.1008183,30.2276529 12.0178231,31.068658 L10.3309346,33.8447367 L13.4399779,35.6246459 Z"
                    id="Fill-12"
                    fill={fill}
                    transform="translate(17.471593, 20.112757) rotate(17.000000) translate(-17.471593, -20.112757) "
                  ></path>
                  <path
                    d="M25.4940085,15.3091564 L26.2521172,13.9387376 C21.9698499,11.3635518 16.4216524,12.8982936 13.9451594,17.3785064 C11.4686664,21.8587193 12.9231747,27.6505011 17.2054419,30.2256869 L17.9635506,28.8552681 C14.3866029,26.7005127 13.1324497,21.9091966 15.2046088,18.1668964 C17.2767679,14.4245963 21.866641,13.1544675 25.4940085,15.3091564"
                    id="Fill-14"
                    fill={fill}
                    transform="translate(19.495079, 21.457917) rotate(17.000000) translate(-19.495079, -21.457917) "
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
